export enum FORM_OF_PAYMENT_TYPE {
  Order = 1,
  CostDocument = 2,
  Payment = 3,
  Booking = 4,
  OrderRestricted = 5,
  CostDocumentOther = 6,
}
